import { useSelector } from 'react-redux';
import { PROMO_TARIFFS } from 'reactApp/appHelpers/configHelpers';
import { heavyFileTrialTariff } from 'reactApp/appHelpers/featuresHelpers/features/heavyFileTrial';
import { type TariffInfo, EShowTariffType } from 'reactApp/components/UploadBigFileDialog/UploadBigFileDialog.types';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import { EProductPeriod } from 'reactApp/modules/products/products.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { type RootState, store as reduxStore } from 'reactApp/store';
import type { Product } from 'reactApp/types/Billing';

// то же, что useTariff, но для обычных функций
export const getUploadBigFileBaseTariff = (fileSizeBytes: number): TariffInfo => {
    const state = reduxStore.getState();
    const { isFull: isOverQuota } = UserSelectors.getCloudSpace(state);

    const trialTariff = heavyFileTrialTariff || PROMO_TARIFFS?.default128GbTrial;

    const trial = ProductsSelectors.getProductById(state, trialTariff) as Product;
    const { product: usualProduct } = ProductsSelectors.getProductAndTariffByQuota(state, fileSizeBytes, EProductPeriod.year, false);
    const isPaidUser = UserSelectors.isPaidUser(state);

    const isTrialUser = !isPaidUser && !isOverQuota && Boolean(trial) && fileSizeBytes < trial?.space.original;

    return {
        trial,
        usualProduct,
        showTariffType: isTrialUser ? EShowTariffType.TRIAL : EShowTariffType.USUAL_TARIFF,
    };
};

export const useTariff = (fileSizeBytes: number): TariffInfo => {
    const { isFull: isOverQuota } = useSelector(UserSelectors.getCloudSpace);

    // tempexp_17995-next-line tempexp_18639-next-line
    const trialTariff = heavyFileTrialTariff || PROMO_TARIFFS?.default128GbTrial;

    // TODO: если id невалидный, то product будет undefined и всё посыпется. Стоит предусмотреть и убрать as Product
    const trial = useSelector((state: RootState) => ProductsSelectors.getProductById(state, trialTariff)) as Product;
    const { product: usualProduct } = useSelector((state: RootState) =>
        ProductsSelectors.getProductAndTariffByQuota(state, fileSizeBytes, EProductPeriod.year, false)
    );
    const isPaidUser = useSelector(UserSelectors.isPaidUser);

    // если в квоту триала помещаются загружаемые файлы, пользователей не платник,
    // не в оверквоте и ему доступен триальный тариф, то показываем его
    const isTrialUser = !isPaidUser && !isOverQuota && Boolean(trial) && fileSizeBytes < trial?.space.original;

    return {
        trial,
        usualProduct,
        showTariffType: isTrialUser ? EShowTariffType.TRIAL : EShowTariffType.USUAL_TARIFF,
    };
};
